import { FieldType } from "../api.js";
import { BaseModelConvertSpec } from "./base.specs.js";
const FundingMethodConvertSpec = {
  ...BaseModelConvertSpec,
  min: FieldType.BigNumber,
  max: FieldType.BigNumber
};
const FundingGroupConvertSpec = {
  ...BaseModelConvertSpec,
  fundingMethods: FundingMethodConvertSpec
};
export {
  FundingGroupConvertSpec,
  FundingMethodConvertSpec
};
